import { LabelRequired } from '../custom/LabelRequired';
import { Autocomplete } from '../fields';
import { useTranslation } from 'react-i18next';
import useAccounts from '../../hooks/useAccounts';
import useIsInputsOnlyLayout from '../../hooks/useIsInputsOnlyLayout';
import amIVisible from '../../componentControl/registry';
import { Box } from '../custom/box';
import { Flex } from '@react-css/flex';

const HalfBox = ({ children }) => {
  return <Box width="45%" ml="0.75rem" mr="0.75rem">
    {children}
  </Box>;
};

export const ShippingSection = (props) => {
  const [isLoading, accountsList] = useAccounts('shipping');
  const [, inventoryCogs] = useAccounts('inventoryCogs');

  const { t } = useTranslation();

  let listOfAccounts = accountsList

  if (amIVisible("show expense account in inventory")) {
    listOfAccounts = inventoryCogs
  }

  const [isInputsOnlyLayout] = useIsInputsOnlyLayout();

  return <Box>
    <Flex>
      {amIVisible("po discount") &&
        <HalfBox>
          <LabelRequired
            notRequired
          >
            {t('Discount')}
          </LabelRequired>
          <Autocomplete
            id="poDiscountAccount"
            name="poDiscountAccount"
            isLoading={isLoading}
            options={accountsList}
            placeholder={isInputsOnlyLayout ? "Enter an account" : 'Select an account'}
          />
        </HalfBox>}
      {amIVisible("po discount additional") &&
        <HalfBox>
          <LabelRequired
            notRequired
          >
            {t('Additional Discount')}
          </LabelRequired>
          <Autocomplete
            id="poAdditionalDiscountAccount"
            name="poAdditionalDiscountAccount"
            isLoading={isLoading}
            options={accountsList}
            placeholder={isInputsOnlyLayout ? "Enter an account" : 'Select an account'}
          />
        </HalfBox>}
    </Flex>
    <Flex mt="1.5rem">
      {amIVisible("shipping account") && <HalfBox>
        <LabelRequired
          htmlFor="shipping"
        >
          {t('Shipping')}
        </LabelRequired>
        <Autocomplete
          id="shipping"
          name="shipping"
          isLoading={isLoading}
          options={listOfAccounts}
          placeholder={isInputsOnlyLayout ? "Enter an account" : 'Select an account'}
        />
      </HalfBox>}
      {amIVisible("freight charges account") && <HalfBox>
        <LabelRequired
          htmlFor="freightCharges"
        >
          {t('Freight charges')}
        </LabelRequired>
        <Autocomplete
          id="freightCharges"
          name="freightCharges"
          isLoading={isLoading}
          options={listOfAccounts}
          placeholder={isInputsOnlyLayout ? "Enter an account" : 'Select an account'}
        />
      </HalfBox>}
    </Flex>
    <Flex mt="1.5rem">
      {amIVisible("other exponses account") && <HalfBox>
        <LabelRequired
          htmlFor="otherExpenses"
        >
          {t('Other expenses')}
        </LabelRequired>
        <Autocomplete
          id="otherExpenses"
          name="otherExpenses"
          isLoading={isLoading}
          options={listOfAccounts}
          placeholder={isInputsOnlyLayout ? "Enter an account" : 'Select an account'}
        />
      </HalfBox>}
    </Flex>
  </Box>
};
